import styled from 'styled-components';

export const AdTopWrapper = styled.div`
  padding: 0;
  @media (min-width: 1024px) {
    min-height: 90px;
  }
  @media (min-width: 768px) {
    min-height: 90px;
  }
  @media (min-width: 330px) {
    min-height: 50px;
  }
`;

export const AdBottomWrapper = styled.div`
  padding: 0;
  @media (min-width: 1024px) {
    min-height: 250px;
  }
  @media (min-width: 768px) {
    min-height: 90px;
  }
  @media (min-width: 330px) {
    min-height: 50px;
  }
`;
